import type { LoginInput, LoginOutput } from '@allocab/allocab-commons-shared-types';
import { queryClient, storage, updateTokens } from '@frontend/shared';
import { getPassengerApi } from '@frontend/shared/passenger-api';
import { useMutation } from '@tanstack/react-query';

/**
 * Login extranet : on hit le même endpoint passenger-api que les autres apps,
 * mais on signale au back via `X-Client-Type: extranet` qu'il s'agit d'un
 * login portail. Le back doit :
 * - refuser un compte de type 'PASSENGER' essayant de se loguer ici (403)
 * - et inversement, refuser un compte 'EXTRANET' sur les apps passenger
 *
 * Spec back §5.A : "Un compte EXTRANET ne peut pas se loguer sur l'app
 * passager et inversement (vérif du type au login)".
 *
 * Le JWT retourné doit embarquer { type: 'EXTRANET', accountId, profiles,
 * scope: { entityIds, contractIds } } pour que les routes /v1/extranet/*
 * puissent faire leur filtrage multi-tenant côté serveur.
 */
const login = (input: LoginInput) =>
  getPassengerApi().post<LoginInput, LoginOutput>('/authentication/v1/user/login', input, {
    skipAuth: true,
    headers: {
      'X-Client-Type': 'extranet',
    },
  });

export const useExtranetLogin = () =>
  useMutation({
    mutationFn: login,
    onSuccess: tokens => {
      storage.setJSONItem('tokens', tokens);
      updateTokens(queryClient, tokens);
    },
  });
